import React from "react";
import { Link } from "react-router-dom";
import LogoBranca from '../assets/logoBranca.png';
import LogoAzul from '../assets/logoAzul.png';
import useTheme from '../context/ThemeContext';


// ==========================================
// FOOTER COMPONENT
// ==========================================

const Footer = () => {

  const { isDark } = useTheme();
  
  return (
  
  <footer style={{ background: 'var(--bg-tertiary)', color: 'var(--tertiary)', padding: '3rem 0 1rem', marginTop: '4rem' }}>
    <div className="container">
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '3rem',
        marginBottom: '3rem',
      }}>
        <div>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontWeight: 800,
            fontSize: '1.5rem',
            color: 'white',
            textDecoration: 'none',
            marginBottom: '1rem',
          }}>
            {/* <div style={{
              width: '40px',
              height: '40px',
              background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <i className="fas fa-bolt"></i>
            </div> */}
            {/* Atende24h */}
            <img
                  src={isDark ? LogoBranca : LogoAzul}
                  alt="Atende24h"
                  style={{ width: '120px' }}
                />
          </Link>
          <p style={{ color: '#94a3b8', lineHeight: 1.6 }}>
            Transformando a comunicação empresarial com tecnologia de ponta. Especialistas em integração WhatsApp e desenvolvimento de softwares sob medida.
          </p>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
            {['linkedin-in', 'instagram', 'github'].map(icon => (
              <a key={icon} href="/redes" style={{
                width: '40px',
                height: '40px',
                background: '#1e293b',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#94a3b8',
                textDecoration: 'none',
              }}>
                <i className={`fab fa-${icon}`}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 style={{ marginBottom: '1rem', }}>Serviços</h4>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {['Automação WhatsApp', 'Chatwoot/N8N', 'Softwares SaaS', 'Consultoria'].map(item => (
              <li key={item} style={{ marginBottom: '0.5rem' }}>
                <a href="/whatsapp" style={{ color: '#94a3b8', textDecoration: 'none' }}>{item}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 style={{ marginBottom: '1rem' }}>Empresa</h4>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {['Sobre Nós', 'Cases', 'Blog', 'Carreiras'].map(item => (
              <li key={item} style={{ marginBottom: '0.5rem' }}>
                <a href="/sobre" style={{ color: '#94a3b8', textDecoration: 'none' }}>{item}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-links">
          <h4 style={{ marginBottom: '1rem', color: 'var(--text-primary)' }}>Legal</h4>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <Link to="/privacidade" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                Política de Privacidade
              </Link>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <Link to="/termos" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                Termos de Uso
              </Link>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <a href="/lgpd" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                LGPD
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div style={{ borderTop: '1px solid #1e293b', paddingTop: '2rem', textAlign: 'center', color: '#64748b', fontSize: '0.9rem' }}>
        <p>&copy; 2026 Atende24h. Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
)};
export default Footer;